// extracted by mini-css-extract-plugin
export default {"container":"HuqpRF","placeInfo":"wx04Ay","ticketInfo":"HW6KqO","ticketPrice":"bU1oLL"};